import React, { useState, useEffect } from 'react';
import { getRuote, analizzaNumeriPerRuota, getStoricoNumeriRuota, getCoppieFrequentiConfronto } from '../services/api';

const ConfrontoRuote = () => {
  const [ruote, setRuote] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [activeTab, setActiveTab] = useState('confronto');
  
  // Confronto state
  const [numeriInput, setNumeriInput] = useState('');
  const [risultatiConfronto, setRisultatiConfronto] = useState(null);
  
  // Storico state
  const [storicoRuota, setStoricoRuota] = useState('');
  const [storicoNumeri, setStoricoNumeri] = useState('');
  const [risultatiStorico, setRisultatiStorico] = useState(null);
  
  // Coppie state
  const [coppieRuota, setCoppieRuota] = useState('');
  const [risultatiCoppie, setRisultatiCoppie] = useState(null);

  useEffect(() => {
    loadRuote();
  }, []);

  const loadRuote = async () => {
    try {
      const res = await getRuote();
      setRuote(res.data);
    } catch (err) {
      console.error('Errore:', err);
    }
  };

  const showMessage = (text, type = 'success') => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 5000);
  };

  const parseNumeri = (input) => {
    return input
      .split(',')
      .map(n => parseInt(n.trim()))
      .filter(n => n >= 1 && n <= 90);
  };

  const handleConfronto = async () => {
    const numeri = parseNumeri(numeriInput);
    if (numeri.length < 1) {
      showMessage('Inserisci almeno un numero', 'error');
      return;
    }
    
    setLoading(true);
    try {
      const res = await analizzaNumeriPerRuota({ numeri });
      setRisultatiConfronto(res.data);
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore analisi', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleStorico = async () => {
    const numeri = parseNumeri(storicoNumeri);
    if (numeri.length < 1 || !storicoRuota) {
      showMessage('Inserisci numeri e seleziona ruota', 'error');
      return;
    }
    
    setLoading(true);
    try {
      const res = await getStoricoNumeriRuota(numeri.join(','), storicoRuota);
      setRisultatiStorico(res.data);
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore ricerca', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleCoppie = async () => {
    setLoading(true);
    try {
      const res = await getCoppieFrequentiConfronto(coppieRuota || null);
      setRisultatiCoppie(res.data);
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore analisi', 'error');
    } finally {
      setLoading(false);
    }
  };

  const getScoreColor = (score, maxScore) => {
    const ratio = score / maxScore;
    if (ratio >= 0.8) return '#22543d';
    if (ratio >= 0.6) return '#2f855a';
    if (ratio >= 0.4) return '#718096';
    return '#a0aec0';
  };

  const getBarWidth = (value, maxValue) => {
    return maxValue > 0 ? Math.round((value / maxValue) * 100) : 0;
  };

  return (
    <div>
      <h2>Confronto Ruote</h2>
      <p style={{ color: '#718096', marginBottom: '20px' }}>
        Analizza su quali ruote i tuoi numeri performano meglio.
      </p>

      {message && (
        <div className={'alert alert-' + (message.type === 'error' ? 'error' : 'success')}>
          {message.text}
        </div>
      )}

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #e2e8f0', paddingBottom: '10px' }}>
        <button 
          className={activeTab === 'confronto' ? 'btn btn-primary' : 'btn btn-secondary'} 
          onClick={() => setActiveTab('confronto')}
        >
          Confronto Numeri
        </button>
        <button 
          className={activeTab === 'storico' ? 'btn btn-primary' : 'btn btn-secondary'} 
          onClick={() => setActiveTab('storico')}
        >
          Storico Estrazioni
        </button>
        <button 
          className={activeTab === 'coppie' ? 'btn btn-primary' : 'btn btn-secondary'} 
          onClick={() => setActiveTab('coppie')}
        >
          Coppie Frequenti
        </button>
      </div>

      {/* Tab Confronto */}
      {activeTab === 'confronto' && (
        <>
          <div className="card" style={{ marginBottom: '20px' }}>
            <h3 className="card-title">Analizza i tuoi numeri</h3>
            <div className="form-group">
              <label className="form-label">Inserisci i numeri da analizzare</label>
              <input
                type="text"
                className="form-input"
                value={numeriInput}
                onChange={(e) => setNumeriInput(e.target.value)}
                placeholder="Es: 7, 14, 23, 45"
              />
              <small style={{ color: '#718096' }}>
                Numeri: {parseNumeri(numeriInput).length > 0 ? parseNumeri(numeriInput).join(', ') : 'nessuno'}
              </small>
            </div>
            <button 
              className="btn btn-primary" 
              onClick={handleConfronto}
              disabled={loading || parseNumeri(numeriInput).length < 1}
            >
              {loading ? 'Analisi in corso...' : 'Analizza su tutte le ruote'}
            </button>
          </div>

          {risultatiConfronto && (
            <div className="card">
              <h3 className="card-title">
                Ranking Ruote per numeri: {risultatiConfronto.numeri_analizzati.join(', ')}
              </h3>
              
              <div style={{ marginBottom: '20px', padding: '15px', background: '#f0fff4', borderRadius: '8px' }}>
                <strong>Ruota consigliata:</strong>{' '}
                <span style={{ fontSize: '1.2rem', color: '#22543d', fontWeight: 'bold' }}>
                  {risultatiConfronto.ruota_consigliata}
                </span>
              </div>

              <table className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Ruota</th>
                    <th>Freq. Totale</th>
                    <th>Media Ritardo</th>
                    <th>Score</th>
                    <th>Dettaglio</th>
                  </tr>
                </thead>
                <tbody>
                  {risultatiConfronto.risultati.map((r) => {
                    const maxScore = risultatiConfronto.risultati[0]?.score || 1;
                    return (
                      <tr key={r.ruota_id} style={{ background: r.ranking <= 3 ? '#f0fff4' : 'inherit' }}>
                        <td>
                          <span style={{
                            display: 'inline-block',
                            width: '24px',
                            height: '24px',
                            borderRadius: '50%',
                            background: r.ranking === 1 ? '#ffd700' : r.ranking === 2 ? '#c0c0c0' : r.ranking === 3 ? '#cd7f32' : '#e2e8f0',
                            textAlign: 'center',
                            lineHeight: '24px',
                            fontWeight: 'bold',
                            fontSize: '0.8rem'
                          }}>
                            {r.ranking}
                          </span>
                        </td>
                        <td>
                          <span className="ruota-badge" style={{ 
                            background: r.ranking <= 3 ? '#2c5282' : '#718096',
                            color: 'white'
                          }}>
                            {r.ruota_nome}
                          </span>
                        </td>
                        <td>
                          <strong>{r.totale_frequenza}</strong>
                          <div style={{
                            width: '100%',
                            height: '6px',
                            background: '#e2e8f0',
                            borderRadius: '3px',
                            marginTop: '4px'
                          }}>
                            <div style={{
                              width: `${getBarWidth(r.totale_frequenza, risultatiConfronto.risultati[0]?.totale_frequenza || 1)}%`,
                              height: '100%',
                              background: '#48bb78',
                              borderRadius: '3px'
                            }}></div>
                          </div>
                        </td>
                        <td>
                          <span style={{ color: r.media_ritardo > 50 ? '#c53030' : '#718096' }}>
                            {r.media_ritardo}
                          </span>
                        </td>
                        <td>
                          <strong style={{ color: getScoreColor(r.score, maxScore), fontSize: '1.1rem' }}>
                            {r.score}
                          </strong>
                        </td>
                        <td>
                          <div style={{ fontSize: '0.8rem' }}>
                            {r.numeri_stats.map(ns => (
                              <div key={ns.numero} style={{ display: 'inline-block', marginRight: '10px' }}>
                                <span className="numero-ball small">{ns.numero}</span>
                                <span style={{ color: '#718096', marginLeft: '3px' }}>
                                  F:{ns.frequenza} R:{ns.ritardo}
                                </span>
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <div style={{ marginTop: '15px', fontSize: '0.85rem', color: '#718096' }}>
                <strong>Legenda:</strong> Freq = Frequenza (quante volte è uscito), R = Ritardo attuale, 
                Score = Indice di performance (frequenza - ritardo/10)
              </div>
            </div>
          )}
        </>
      )}

      {/* Tab Storico */}
      {activeTab === 'storico' && (
        <>
          <div className="card" style={{ marginBottom: '20px' }}>
            <h3 className="card-title">Cerca numeri in una ruota</h3>
            <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
              <div className="form-group" style={{ flex: 2, minWidth: '200px' }}>
                <label className="form-label">Numeri</label>
                <input
                  type="text"
                  className="form-input"
                  value={storicoNumeri}
                  onChange={(e) => setStoricoNumeri(e.target.value)}
                  placeholder="Es: 7, 14, 23"
                />
              </div>
              <div className="form-group" style={{ flex: 1, minWidth: '150px' }}>
                <label className="form-label">Ruota</label>
                <select
                  className="form-select"
                  value={storicoRuota}
                  onChange={(e) => setStoricoRuota(e.target.value)}
                >
                  <option value="">Seleziona...</option>
                  {ruote.map(r => (
                    <option key={r.id} value={r.id}>{r.nome}</option>
                  ))}
                </select>
              </div>
            </div>
            <button 
              className="btn btn-primary" 
              onClick={handleStorico}
              disabled={loading}
            >
              {loading ? 'Ricerca...' : 'Cerca'}
            </button>
          </div>

          {risultatiStorico && (
            <div className="card">
              <h3 className="card-title">
                Estrazioni su {risultatiStorico.ruota} con numeri: {risultatiStorico.numeri_cercati.join(', ')}
              </h3>
              <p style={{ color: '#718096', marginBottom: '15px' }}>
                Trovate {risultatiStorico.n_risultati} estrazioni
              </p>
              
              {risultatiStorico.estrazioni.length === 0 ? (
                <p>Nessuna estrazione trovata con questi numeri.</p>
              ) : (
                <table className="table">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Numeri Estratti</th>
                      <th>Trovati</th>
                    </tr>
                  </thead>
                  <tbody>
                    {risultatiStorico.estrazioni.map((e, idx) => (
                      <tr key={idx}>
                        <td>{new Date(e.data).toLocaleDateString('it-IT')}</td>
                        <td>
                          {e.numeri_estratti.map(n => (
                            <span 
                              key={n} 
                              className="numero-ball small"
                              style={{
                                background: e.numeri_trovati.includes(n) ? '#48bb78' : '#e2e8f0',
                                color: e.numeri_trovati.includes(n) ? 'white' : '#4a5568'
                              }}
                            >
                              {n}
                            </span>
                          ))}
                        </td>
                        <td>
                          <span style={{ 
                            fontWeight: 'bold', 
                            color: e.n_trovati >= 3 ? '#22543d' : e.n_trovati >= 2 ? '#2f855a' : '#718096'
                          }}>
                            {e.n_trovati}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </>
      )}

      {/* Tab Coppie */}
      {activeTab === 'coppie' && (
        <>
          <div className="card" style={{ marginBottom: '20px' }}>
            <h3 className="card-title">Coppie di numeri più frequenti</h3>
            <div className="form-group">
              <label className="form-label">Ruota (vuoto = tutte)</label>
              <select
                className="form-select"
                style={{ maxWidth: '200px' }}
                value={coppieRuota}
                onChange={(e) => setCoppieRuota(e.target.value)}
              >
                <option value="">Tutte le ruote</option>
                {ruote.map(r => (
                  <option key={r.id} value={r.id}>{r.nome}</option>
                ))}
              </select>
            </div>
            <button 
              className="btn btn-primary" 
              onClick={handleCoppie}
              disabled={loading}
            >
              {loading ? 'Analisi...' : 'Analizza coppie'}
            </button>
          </div>

          {risultatiCoppie && (
            <div className="card">
              <h3 className="card-title">
                Top 20 coppie su {risultatiCoppie.ruota}
              </h3>
              <p style={{ color: '#718096', marginBottom: '15px' }}>
                Analizzate {risultatiCoppie.n_estrazioni_analizzate} estrazioni
              </p>
              
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px' }}>
                {risultatiCoppie.coppie.map((c) => (
                  <div 
                    key={c.ranking}
                    style={{
                      padding: '12px',
                      background: c.ranking <= 3 ? '#f0fff4' : '#f7fafc',
                      border: c.ranking <= 3 ? '2px solid #48bb78' : '1px solid #e2e8f0',
                      borderRadius: '8px'
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        background: c.ranking === 1 ? '#ffd700' : c.ranking === 2 ? '#c0c0c0' : c.ranking === 3 ? '#cd7f32' : '#e2e8f0',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        fontSize: '0.8rem'
                      }}>
                        {c.ranking}
                      </span>
                      <span style={{ fontWeight: 'bold', color: '#2c5282' }}>
                        {c.frequenza}x
                      </span>
                    </div>
                    <div style={{ marginTop: '10px', textAlign: 'center' }}>
                      {c.coppia.map(n => (
                        <span key={n} className="numero-ball">{n}</span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ConfrontoRuote;
